import apiClient from './config';

export default {
  // Récupérer tous les rendez-vous
  getAllAppointments(params = {}) {
    return apiClient.get('/appointment/list', { params });
  },

  // Récupérer un rendez-vous par ID
  getAppointmentById(id) {
    return apiClient.get(`/appointment/${id}`);
  },

  // Créer un nouveau rendez-vous
  createAppointment(data) {
    return apiClient.post('/appointment/admins/prendre', data);
  },

  // Mettre à jour un rendez-vous
  updateAppointment(id, data) {
    return apiClient.put(`/appointment/${id}`, data);
  },

  // Supprimer/Annuler un rendez-vous
  deleteAppointment(id) {
    return apiClient.delete(`/appointment/supprimer/${id}`);
  },

  // Annuler un rendez-vous (change le statut à "annulé")
  cancelAppointment(id) {
    return apiClient.put(`/appointment/admins/annuler/${id}`);
  },

  // Envoyer un rappel SMS/Email
  sendReminder(id) {
    return apiClient.post(`/appointment/admins/send-reminder/${id}`);
  },

  // Valider les données d'un rendez-vous
  validateAppointment(data) {
    return apiClient.post('/appointment/validate', data);
  },

  // Récupérer les disponibilités
  getAvailabilities(data) {
    return apiClient.post('/appointment/disponibilites', data);
  },

  // Filtrer par statut
  getAppointmentsByStatus(status) {
    return apiClient.get('/appointment/list', { params: { status } });
  },

  // Rechercher des rendez-vous
  searchAppointments(query) {
    return apiClient.get('/appointment/search', { params: { q: query } });
  },

  // Récupérer les rendez-vous d'un client
  getClientAppointments(clientId) {
    return apiClient.get(`/appointment/client/${clientId}`);
  },

  // Récupérer les rendez-vous d'un employé
  getStaffAppointments(staffId) {
    return apiClient.get(`/appointment/staff/${staffId}`);
  },

  // Import & Export
  // Importer des rendez-vous depuis un fichier CSV
  importCsv(formData) {
    return apiClient.post('/firm/appointments/import-csv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Importer des rendez-vous depuis un fichier iCalendar (.ics)
  importIcal(formData) {
    return apiClient.post('/firm/appointments/import-ical', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Télécharger le template CSV
  downloadCsvTemplate() {
    return apiClient.get('/firm/appointments/template-csv', {
      responseType: 'text'
    });
  },

  // Exporter tous les rendez-vous en iCalendar
  exportIcal() {
    return apiClient.get('/firm/appointments/export-ical', {
      responseType: 'text'
    });
  },
};
